export const ROUTES = {
    REQUEST_NEW: '/hrm/approval-requests/my-requests/new',
    REQUEST_LIST: '/hrm/approval-requests/my-requests/ALL',
    MY_REQUEST_LIST: '/hrm/approval-requests/my-requests/'
};
